<template>
	<div>
		<div class="pro_main">
			<div class="selector">
				<span class="label">渠道查询</span>
				<div class="input-search el-input">
					<input type="text"
					  v-model="keyword"
					  @keyup.enter="getlist(true)"
					  autocomplete="off" maxlength="20" placeholder="请输入渠道名称" class="el-input__inner">
				</div>
				<el-button class="btn" type="primary" @click="getlist(true)">查询</el-button>
				<el-button class="btn btn-add" type="primary" @click="showAddOrEdit()">+添加渠道</el-button>
			</div>
	
			<el-table v-loading="loading" :data="tableData" style="width: 100%;min-height: 400px;">
				<el-table-column prop="name" label="渠道名称" align="center">
				</el-table-column>
				<el-table-column prop="def_rate" label="分润比例" align="center">
					<template slot-scope="scope">
						{{scope.row.def_rate}}%
					</template>
				</el-table-column>
				<el-table-column prop="linkman" label="联系人" align="center">
				</el-table-column>
				<el-table-column prop="phone" label="联系电话" align="center">
				</el-table-column>
				<el-table-column prop="dizhi" label="地址" :show-overflow-tooltip="true" width="300" align="center">
					<template slot-scope="scope">
						{{scope.row.dizhi}}
					</template>
				</el-table-column>
				<el-table-column align="center" width="300">
					<template slot="header" slot-scope="scope">
						<div>操作</div>
					</template>
					<template slot-scope="scope">
						<div>
							<el-button type="text" size="medium" @click="showAddSaleData(scope.row.channel_id)">销售数据导入</el-button>
							<el-button type="text" size="medium" @click="goDetail(scope.row.id)">详情</el-button>
							<el-button type="text" size="medium" @click="showAddOrEdit(scope.row.id)">编辑</el-button>
							<el-button type="text" size="medium" @click="del(scope.row.id)">删除</el-button>
						</div>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页器 -->
			<div class="block" style="padding: 40px;background: #ffffff;" v-if="tableData.length > 0">
				<el-pagination background align='center' @size-change="handleSizeChange"
					@current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
					layout="total, prev, pager, next, jumper" :pager-count='5' :total="total">
				</el-pagination>
			</div>
		</div>
		
		<dialog-add-or-edit :show="addOrEdit" :oc_id="oc_id" @close="closeAddOrEdit" @success="closeAddOrEdit"></dialog-add-or-edit>
		<dialog-bill :show="addSaleData" :channel_id="channel_id" @close="closeAddSaleData" @success="closeAddSaleData"></dialog-bill>
	</div>
</template>

<script>
	import {
		getChannelList,
		delChannel
	} from '@/api/channel';
	import dialogBill from '@/components/channel/add-bill.vue';
	import dialogAddOrEdit from '@/components/channel/add_edit.vue';
	
	export default {
		name: '',
		components: {
			dialogBill, // 销售数据导入
			dialogAddOrEdit // 添加/编辑
		},
		data() {
			return {
				currentPage: 1, // 当前页码
				total: 0, // 总条数
				pageSize: 10, // 每页的数据条数
				loading: true,
				tableData: [],
				keyword: '',
				addSaleData: false, // 销售数据导入的弹框显示状态
				channel_id:0, // 渠道id
				addOrEdit: false ,// 添加编辑弹框显示状态
				oc_id:0, // 渠道关系id
			}
		},
		created() {
			let keypage = localStorage.getItem('keypage');
			let activeName = localStorage.getItem('activeName');
			if (keypage) {
				this.currentPage = parseInt(keypage);
				this.activeName = activeName
				localStorage.setItem('keypage', '')
				localStorage.setItem('activeName', '')
			}
			this.getlist();
		},
		methods: {
			// 获取列表数据
			getlist(refresh=false) {
				if (refresh) {
					this.currentPage = 1;
				}
				getChannelList({
					page: this.currentPage,
					pageSize: 10,
					name: this.keyword,
				}).then(res => {
					if (res.code == 0) {
						this.loading = false;
						this.total = res.data.allcount;
						this.tableData = res.data.list;
					} else {
						this.$message.error(res.message);
					}
				})
			},
			
			// 去详情页面
			goDetail(id) {
				this.$router.push({
					path: '/customer/channel-detail',
					query: {oc_id:id}
				});
			},
			
			// 删除渠道
			del(id) {
				this.$confirm('确认删除该渠道?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					delChannel({
						oc_id: id
					}).then(res => {
						if (res.code == 0) {
							this.$message.success(res.message);
							this.getlist();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
			
				});
			},
			
			// 每页条数改变时触发 选择一页显示多少行
			handleSizeChange(val) {
				this.currentPage = 1;
				this.pageSize = val;
			},
			
			//当前页改变时触发 跳转其他页
			handleCurrentChange(val) {
				console.log(val);
				this.currentPage = val;
				this.getlist();
			},
			
			// 销售数据导入 弹框
			showAddSaleData(channel_id){
				this.channel_id = channel_id;
				this.addSaleData = true;
			},
			
			// 关闭销售数据导入
			closeAddSaleData() {
				this.addSaleData = false
			},
			
			// 添加/编辑 弹框
			showAddOrEdit(id){
				this.oc_id = id;
				this.addOrEdit = true;
			},
			
			// 关闭添加/编辑
			closeAddOrEdit() {
				this.oc_id = 0;
				this.addOrEdit = false
				this.getlist();
			},
		},
		
	}
</script>

<style scoped>
	.selector {
		padding: 0 15px 15px 0;
		height: 40px;
		display: flex;
		align-items: center;
	}
	.input-search {
		width: 384px;
	}
	.select-classify {
		width: 150px;
	}
	.btn {
		width: 102px;
		height: 40px;
		margin-left: 20px !important;
	}
	.btn-add, .btn-add:hover {
		border-color: #FF8700;
		background: #FF8700;
	}
	.label {
		margin: 0 10px;
		font-size: 14px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #333333;
	}
</style>
<style lang="css">
  .el-tooltip__popper {
    max-width: 30%;
  }
</style>
